import React, { useContext, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { FundraiserForm } from './FundraiserForm';
import { FundraiserForm as FundraiserFormV2 } from './v2/FundraiserForm';
import { Fundraisers } from './Fundraisers';
import Registrations from './Registrations';

const FUNDRAISER_BETA = import.meta.env.VITE_FUNDRAISER_BETA === 'true';

export const FundraiserIndex = () => {
  return (
    <Switch>
      <Route exact path='/fundraisers' component={Fundraisers} />
      <Route exact path='/fundraisers/add' component={FundraiserForm} />
      <Route exact path='/fundraisers/edit/:id' component={FundraiserForm} />
      <Route
        exact
        path='/fundraisers/registrations/:id'
        component={Registrations}
      />
      {FUNDRAISER_BETA && (
        <>
          <Route exact path='/fundraisers/v2/add' component={FundraiserFormV2} />
          <Route exact path='/fundraisers/v2/edit/:id' component={FundraiserFormV2} />
        </>
      )}
    </Switch>
  );
};
